import api from '@/services/api'

import { apiErrorHandler } from '../utils/apiErrors'

const FEEDBACK_ENDPOINT = 'feedbacks/'

export default class FeedbackAPI {
  /**
   * Instantiate a new `FeedbackAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `FeedbackAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new FeedbackAPI(cls)
  }

  /* Get the API Client. */
  get client() {
    return api.getApiClient()
  }

  /**
   * Create a new Feedback through the API.
   * @param {Event} feedback - Data for the feedback to be created.
   * @returns {Promise} - Promise wrapping the newly-created `Event` data.
   **/
  async create(feedback) {
    const url = FEEDBACK_ENDPOINT + 'create/'
    const data = this.cls.toAPI(feedback)

    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Create feedback API error' }))
  }
}
